/******/ (() => { // webpackBootstrap
/*!*******************************************!*\
  !*** ./src/js/product-recommendations.js ***!
  \*******************************************/
/*
BG: This function uses the recommended products API by Shopify. We firstly pass over the product ID we want to display recommended on, and then for each result, request the product.card template to get the look.
*/
var recommendedProducts = function recommendedProducts() {
  //determine if the recommendProducts class section is present
  var recommended = document.querySelector(".js-recommended-products");

  //if it is....
  if (!!recommended) {
    //Get the productID from the data attribute
    var productID = parseInt(recommended.getAttribute("data-product-id"));

    //using that productID, query the recommended products API
    fetch(window.Shopify.routes.root + "recommendations/products.json?product_id=".concat(productID, "&limit=4")).then(function (response) {
      return response.json();
    }).then(function (_ref) {
      var products = _ref.products;
      //with the response, loop through each product.
      products.forEach(function (product, index) {
        //console.log(product.handle)
        //we run a second fetch to get the product card HTML markup
        fetch(window.Shopify.routes.root + "products/".concat(product.handle, "?view=card")).then(function (response) {
          return response.text();
        }).then(function (html) {
          recommended.innerHTML += "<li class=\"bg-white\">".concat(html, "</li>");
        });
      });
    })["catch"](function (error) {
      console.error("Error:", error);
    });
  }
};
recommendedProducts();
/******/ })()
;